import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const handleMenuClose = () => {
    setOpen(false);
  };
  return (
    <>
      <style>{`
        /* BASIC RESET */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: Arial, sans-serif;
        }

        /* NAVBAR */
        .navbar {
          width: 100%;
          padding: 15px 25px;
          background: #222;
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: fixed;
          top: 0;
          z-index: 1000;
        }

        .logo {
          font-size: 20px;
          font-weight: bold;
          color: #ffcc00;
          text-decoration: none;
        }

        .nav-links {
          list-style: none;
          display: flex;
          gap: 25px;
        }

        .nav-links li a {
          text-decoration: none;
          color: white;
          font-size: 16px;
          transition: 0.3s;
        }

        .nav-links li a:hover {
          color: #ffcc00;
        }

        /* MOBILE MENU BUTTON */
        .menu-btn {
          display: none;
          font-size: 30px;
          color: white;
          cursor: pointer;
        }

        /* ===========================
            RESPONSIVE NAVBAR
        =============================*/
        
        @media (max-width: 768px) {
          .nav-links {
            display: ${open ? "flex" : "none"};
            flex-direction: column;
            background: #222;
            position: absolute;
            top: 60px;
            right: 0;
            width: 180px;
            padding: 15px;
            border-radius: 0 0 0 10px;
            animation: fadeIn 0.3s ease-in-out;
          }

          .menu-btn {
            display: block;
          }
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* NAVBAR */}
      <div className="navbar">
        <Link to="/" className="logo">Lakshya Group of Institute</Link>

        <ul className="nav-links">
          <li><Link to="/" onClick={handleMenuClose}>Home</Link></li>
          <li><Link to="/courses" onClick={handleMenuClose}>Courses</Link></li>
          <li><Link to="/notes" onClick={handleMenuClose}>Notes</Link></li>
          <li><Link to="/scholarship" onClick={handleMenuClose}>Scholarship</Link></li>
          <li><Link to="/payment" onClick={handleMenuClose}>Payment/Registration</Link></li>
          <li><Link to="/certificate" onClick={handleMenuClose}>Certificate</Link></li>
          <li><Link to="/result" onClick={handleMenuClose}>Result</Link></li>
          <li><Link to="/success/gallery" onClick={handleMenuClose}>Success Gallery</Link></li>
          <li><Link to="/about" onClick={handleMenuClose}>About Us</Link></li>
          <li><Link to="/contact" onClick={handleMenuClose}>Contact</Link></li>


        </ul>

        {/* Mobile Menu Button */}
        <div className="menu-btn" onClick={() => setOpen(!open)}>
          ☰
        </div>
      </div>
    </>
  );
}
